import React, { ReactNode } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import * as style from './style.module.scss';

interface LayoutProps {
  children: ReactNode;
}

const App = ({ children }: LayoutProps) => {
  return (
    <>
      <figure className={style.pageBackground}>
        <StaticImage
          className={style.pageBackground__image}
          src="../../images/background.jpg"
          alt="Background"
        />
      </figure>
      <article className={style.page}>{children}</article>
    </>
  );
};

export default App;
